export const SET_SETTINGS = 'SET_SETTINGS'

export const setSettings = ({ settingsKey, settingsValue }) => ({
  type: SET_SETTINGS,
  settingsKey,
  settingsValue,
})
